import React from "react";

export default function PrivacyAndPolicy() {
  // const redirectUrl = process.env.REACT_APP_REDIRECTION_URL_PLAN;
  return (
    <p className="mt-2 privacy_policy">
      We follow GDPR security requirements. Please read and accept our privacy
      policy & Terms & Conditions before sign-up.
      <a
        target="_blank"
        href={`https://caremagnus.com/privacy-policy`}
        className="seeDetails m-0"
      >
        Privacy Policy
      </a>{" "}
      &
      <a
        target="_blank"
        href={`https://caremagnus.com/terms-conditions`}
        className="seeDetails m-0"
      >
        Terms & Conditions{" "}
      </a>{" "}
    </p>
  );
}
